export default "__VITE_ASSET__RXqAi0Iw__"